// extracted by mini-css-extract-plugin
module.exports = {"overlay":"portal_overlay__s5842","overlay__alt":"portal_overlay__alt__37pkZ"};